// extracted by mini-css-extract-plugin
module.exports = {"vnrTitle":"TitleSection_vnrTitle__Knj-S","title":"TitleSection_title__36p7M","forexTitle":"TitleSection_forexTitle__2nKNE","readMore":"TitleSection_readMore__1wD3E"};